<template>

  <!-- 금시세표 · 국제환율 (UI만 구성 - 시세 API 연동 전이라 값은 null → — 표시. docs/PRICE_FEATURE_PLAN.md 참고) -->
  <div class="kd-price">
    <div class="wrap">

      <div class="eyebrow">Gold · Exchange Rate</div>
      <h1 class="title">금시세표 · 국제환율</h1>
      <p class="base-time">기준일시 {{ baseTime || '—' }}<span class="sep">·</span>등락은 전일 대비</p>

      <div class="boards">

        <!-- 금값 시세 (소비자 구매가/판매가) -->
        <section class="board-wrap">
          <div class="sec-head">
            <h2>Gold Price <small>금값 시세</small></h2>
          </div>
          <div class="board">
            <table class="ptable metal">
              <colgroup>
                <col class="c-label">
                <col>
                <col>
              </colgroup>
              <thead>
                <tr>
                  <th>비고</th>
                  <th>내가 살 때<span class="sub">(돈, 3.75g)</span><span class="sub2">소비자 구매가</span></th>
                  <th>내가 팔 때<span class="sub">(돈, 3.75g)</span><span class="sub2">소비자 판매가</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in metals" :key="item.key">
                  <th class="label">{{ item.kor }}<span class="sub">{{ item.eng }}</span></th>
                  <td>{{ fmt(item.buy) }}<span v-if="item.buy != null" class="unit">원</span>
                    <span v-if="item.buy_diff != null" class="chg" :class="chgClass(item.buy_diff)">{{ chgText(item.buy_diff, 0) }}<em>{{ pct(item.buy_rate) }}</em></span></td>
                  <td>{{ fmt(item.sell) }}<span v-if="item.sell != null" class="unit">원</span>
                    <span v-if="item.sell_diff != null" class="chg" :class="chgClass(item.sell_diff)">{{ chgText(item.sell_diff, 0) }}<em>{{ pct(item.sell_rate) }}</em></span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- 국제 금시세, 국제 은시세, 국제 환율 -->
        <section class="board-wrap">
          <div class="sec-head">
            <h2>International <small>국제 금시세 · 국제 은시세 · 국제 환율</small></h2>
          </div>
          <div class="board">
            <!-- 12칸 그리드: 시세 3열은 4칸씩, 통화 4열은 3칸씩 -->
            <table class="ptable intl">
              <colgroup>
                <col class="c-label">
                <col v-for="n in 12" :key="n">
              </colgroup>
              <thead>
                <tr>
                  <th>비고</th>
                  <th colspan="4">온스당<span class="sub">(USD)</span></th>
                  <th colspan="4">돈당<span class="sub">(3.75g)</span></th>
                  <th colspan="4">그램당<span class="sub">(g)</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in intl" :key="item.key">
                  <th class="label">{{ item.kor }}</th>
                  <td colspan="4"><span v-if="item.oz != null" class="unit pre">$</span>{{ fmt(item.oz) }}
                    <span v-if="item.oz_diff != null" class="chg" :class="chgClass(item.oz_diff)">{{ chgText(item.oz_diff, 2) }}<em>{{ pct(item.oz_rate) }}</em></span></td>
                  <td colspan="4">{{ fmt(item.don) }}<span v-if="item.don != null" class="unit">원</span>
                    <span v-if="item.don_diff != null" class="chg" :class="chgClass(item.don_diff)">{{ chgText(item.don_diff, 0) }}<em>{{ pct(item.don_rate) }}</em></span></td>
                  <td colspan="4">{{ fmt(item.gram) }}<span v-if="item.gram != null" class="unit">원</span>
                    <span v-if="item.gram_diff != null" class="chg" :class="chgClass(item.gram_diff)">{{ chgText(item.gram_diff, 0) }}<em>{{ pct(item.gram_rate) }}</em></span></td>
                </tr>
                <tr class="rate-head">
                  <th class="label" rowspan="2">국제환율</th>
                  <th v-for="cur in rates" :key="cur.code" colspan="3">{{ cur.kor }}<span class="sub">({{ cur.sub || cur.code }})</span></th>
                </tr>
                <tr class="rate-val">
                  <td v-for="cur in rates" :key="cur.code" colspan="3">{{ fmt(cur.value) }}<span v-if="cur.value != null" class="unit">원</span>
                    <span v-if="cur.diff != null" class="chg" :class="chgClass(cur.diff)">{{ chgText(cur.diff, 2) }}<em>{{ pct(cur.rate) }}</em></span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

      </div>

    </div>
  </div>

</template>
<script>

export default {

    mounted() {
      this.loadprice();
    },

    data: () => ({

      baseTime:null,  //시세 기준일시

      //금값 시세 - 1돈(3.75g) 기준 소비자 구매가/판매가
      metals:[
          {key:'gold24',   kor:'순금시세',  eng:'GOLD 24K',          buy:null, sell:null}
        , {key:'gold18',   kor:'18K 금값',  eng:'GOLD 75.0%',        buy:null, sell:null}
        , {key:'gold14',   kor:'14K 금값',  eng:'GOLD 58.5%',        buy:null, sell:null}
        , {key:'gold12',   kor:'12K 금값',  eng:'GOLD 50.0%',        buy:null, sell:null}
        , {key:'gold10',   kor:'10K 금값',  eng:'GOLD 41.6%',        buy:null, sell:null}
        , {key:'platinum', kor:'백금',      eng:'Platinum 999.0%',   buy:null, sell:null}
        , {key:'silver',   kor:'은',        eng:'Silver 999.0%',     buy:null, sell:null}
      ].map(item => ({...item, buy_diff:null, buy_rate:null, sell_diff:null, sell_rate:null})),   //전일 대비 변동 (반응형 위해 미리 선언)

      //국제 금/은 시세
      intl:[
          {key:'gold',   kor:'국제 금 시세', oz:null, don:null, gram:null}
        , {key:'silver', kor:'국제 은 시세', oz:null, don:null, gram:null}
      ].map(item => ({...item, oz_diff:null, oz_rate:null, don_diff:null, don_rate:null, gram_diff:null, gram_rate:null})),

      //국제 환율 (원화 기준)
      rates:[
          {code:'USD', kor:'미화', value:null}
        , {code:'CNY', kor:'위안', value:null}
        , {code:'JPY', kor:'엔',   value:null, sub:'JPY 100'}   //100엔 기준
        , {code:'EUR', kor:'유로', value:null}
      ].map(item => ({...item, diff:null, rate:null})),

    }),

    methods: {

      //시세 조회 - 서버가 30분마다 수집한 DB 값 (실패 시 — 표시 유지)
      loadprice(){
        this.$http.post(this.$host+'/GuestPriceInfo',{
        })
        .then((result)=>{
          if(result.data.resultCode == 0 && result.data.resultData != null){
            const data = result.data.resultData;
            this.baseTime = data.baseTime;
            //값 + 전일 대비 변동(_diff, _rate)
            data.metals.forEach(item => {
              const target = this.metals.find(m => m.key == item.key);
              if(target){ Object.assign(target, item); }
            });
            data.intl.forEach(item => {
              const target = this.intl.find(m => m.key == item.key);
              if(target){ Object.assign(target, item); }
            });
            data.rates.forEach(item => {
              const target = this.rates.find(m => m.code == item.code);
              if(target){ Object.assign(target, item); }
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });
      },

      //값이 없으면 — (단위는 템플릿에서 작은 글씨로 별도 표시)
      fmt(value){
        if(value == null) return '—';
        return Number(value).toLocaleString(undefined, {maximumFractionDigits:2});
      },

      //전일 대비 - 상승 빨강, 하락 파랑, 보합 회색
      chgClass(diff){
        return diff > 0 ? 'up' : diff < 0 ? 'dn' : 'eq';
      },

      chgText(diff, digits){
        const mark = diff > 0 ? '▲' : diff < 0 ? '▼' : '-';
        return mark + ' ' + Math.abs(diff).toLocaleString(undefined, {minimumFractionDigits:digits, maximumFractionDigits:digits});
      },

      pct(rate){
        return rate == null ? '' : '(' + Math.abs(rate).toFixed(2) + '%)';
      },

    },

}
</script>


<style scoped>

.kd-price{
  --panel:#161616; --panel2:#1f1f1f; --line:#2c2c2c; --muted:#9a9a9a; --gold:#d4b56a;
  background:#0a0a0a;
  color:#ffffff;
  min-height:100%;
  padding:56px 0 60px;
  font-family:'Inter','Noto Sans KR',sans-serif !important;
  -webkit-font-smoothing:antialiased;
  word-break:keep-all;
}
.wrap{max-width:1200px;margin:0 auto;padding:0 40px}
.eyebrow{font-size:12px;letter-spacing:.2em;text-transform:uppercase;color:var(--gold);font-weight:600;margin-bottom:14px}
.title{margin:0;font-size:32px;font-weight:700;letter-spacing:-.5px;color:#ffffff}
.base-time{margin:10px 0 0;font-size:13px;color:var(--muted)}

.boards{margin-top:36px;display:grid;grid-template-columns:1fr 1fr;gap:24px;align-items:start}
.board-wrap{min-width:0}
.sec-head{display:flex;align-items:baseline;margin-bottom:14px}
.sec-head h2{margin:0;font-size:20px;font-weight:700;letter-spacing:-.3px;color:#ffffff}
.sec-head h2 small{font-family:'Noto Sans KR',sans-serif;font-weight:400;font-size:13px;color:var(--muted);margin-left:8px}

.board{background:var(--panel);border:1px solid var(--line);border-radius:16px;overflow:hidden}

/* 시세 표 */
.ptable{width:100%;border-collapse:collapse;table-layout:fixed;font-variant-numeric:tabular-nums}
.ptable th,
.ptable td{border:1px solid var(--line);padding:12px 6px;text-align:center;vertical-align:middle;line-height:1.3}
/* 바깥 테두리는 .board가 그리므로 표 외곽선 제거 */
.ptable tr:first-child th,
.ptable tr:first-child td{border-top:0}
.ptable tr:last-child th,
.ptable tr:last-child td{border-bottom:0}
.ptable th:first-child,
.ptable td:first-child{border-left:0}
.ptable th:last-child,
.ptable td:last-child{border-right:0}
.ptable.intl tr.rate-head + tr td:first-child{border-left:1px solid var(--line)}

.ptable thead th,
.ptable tr.rate-head th{background:var(--panel2);color:var(--gold);font-size:13px;font-weight:600}
.ptable th.label,
.ptable tr.rate-head th.label{background:#121212;color:#e8e8e8;font-size:13.5px;font-weight:500;font-family:'Noto Sans KR',sans-serif}
.ptable td{color:#ffffff;font-size:15px;font-weight:600;height:52px}
.ptable .sub{display:block;font-size:11px;font-weight:400;color:var(--muted);margin-top:2px}
.ptable .sub2{display:block;font-size:11px;font-weight:400;color:var(--muted)}
.ptable .unit{font-size:11px;font-weight:400;color:var(--muted);margin-left:1px}
.ptable .unit.pre{margin-left:0;margin-right:1px}
.base-time .sep{margin:0 6px}

/* 전일 대비 변동 */
.ptable .chg{display:block;margin-top:3px;font-size:11px;font-weight:500;line-height:1.25;white-space:nowrap}
.ptable .chg em{font-style:normal;margin-left:3px}
.ptable .chg.up{color:#e5675c}
.ptable .chg.dn{color:#5ea0e6}
.ptable .chg.eq{color:var(--muted)}

.metal .c-label{width:34%}
.intl .c-label{width:24%}

@media (max-width:1024px){
  .boards{grid-template-columns:1fr;gap:32px}
}
@media (max-width:640px){
  .wrap{padding:0 18px}
  .kd-price{padding:36px 0 40px}
  .eyebrow{font-size:11px;letter-spacing:.12em}
  .title{font-size:26px}
  .boards{margin-top:28px}
  .sec-head{flex-wrap:wrap;gap:2px}
  .sec-head h2{font-size:18px}
  .board{border-radius:12px}
  .ptable th,
  .ptable td{padding:10px 4px}
  .ptable thead th,
  .ptable tr.rate-head th{font-size:12px}
  .ptable th.label{font-size:12.5px}
  .ptable td{font-size:13.5px;height:46px}
  .ptable .sub,
  .ptable .sub2{font-size:10px}
  .intl .c-label{width:20%}
  .ptable .unit{font-size:9.5px}
  /* 환율 값 칸은 4칸으로 나뉘어 가장 좁음 - 단위(원)를 숫자 아래 줄로 내려 숫자 폭 확보 */
  .ptable tr.rate-val td{font-size:13px;padding:8px 2px}
  .ptable tr.rate-val td .unit{display:block;margin:0;line-height:1.1}
  .ptable .chg{font-size:10px}
  /* 국제시세·환율 칸은 좁아서 금액과 %를 두 줄로 */
  .ptable.intl .chg em{display:block;margin-left:0}
}

</style>
